module.exports = __webpack_public_path__ + "media/dogs/dachshund-in-box-0c8362fd.svg";